import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  movementReferenceNumber?: string;
  lrns: string[];
}

export const useSendDeclarationsByLrn = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ batchId, movementReferenceNumber, lrns = [] }: HookProps) => {
    await request({
      path: `declarations/${batchId}/resend-declarations-with-same-lrn`,
      method: 'POST',
      authenticate: true,
      dataObject: { movementReferenceNumber, lrns },
    });
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-groups'] });
      toast.success('Started sending all declarations!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending all declarations!`);
    },
  });
};
